/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Numberstitle1Inputs */

const en_numberstitle1 = /** @type {(inputs: Numberstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numbers`)
};

const de_numberstitle1 = /** @type {(inputs: Numberstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen`)
};

/**
* | output |
* | --- |
* | "Numbers" |
*
* @param {Numberstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const numberstitle1 = /** @type {((inputs?: Numberstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Numberstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_numberstitle1(inputs)
	return de_numberstitle1(inputs)
});
export { numberstitle1 as "numbersTitle" }